import { LeaseAbstract, EscalationType } from '../../types';

// Mock Lease Abstracts
export const mockLeaseAbstracts: LeaseAbstract[] = [
  {
    id: '1',
    documentId: '1',
    leaseStart: '2023-03-01',
    leaseEnd: '2028-02-28',
    rentPerSF: 32.50,
    gla: 5000,
    escalationType: EscalationType.Fixed,
    tenant: 'ABC Corporation',
    property: '123 Main St',
    securityDeposit: 13541.67,
    termRenewalOptions: 'Two 5-year options at 95% of fair market value',
    notes: 'Tenant responsible for all utilities and janitorial services',
  },
];
